import * as React from 'react';
import {connect} from 'react-redux';

import moment from 'moment';

import {DateHeader} from 'shells/date-header/date-header';
import {ActivityListItem} from 'shells/list-item/activity-list-item';
import {ListViewInfiniteActivities} from 'shells/list-view/list-view-infinite-activities';
import type {Indices} from 'shells/list-view/list-view-infinite-activities';

import {GetCalendarSync} from '../../../setup/calendar/get-calendar-sync';

import type {NutshellState} from '../../../../store';

// @ts-expect-error
import * as actions from '../../dashboard-actions';
// @ts-expect-error
import * as dashboardSelectors from '../../dashboard-selectors';

import * as selectors from './activities-selectors';

import styles from './activity-list.module.css';

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        onClearActivityListError: () => {
            dispatch(actions.clearActivityListError());
        },
        onScrolledToDate: (date) => {
            dispatch(actions.updateActivityListScrolledToDate(date));
        },
        onFetchMoreRows: () => {
            return dispatch(actions.fetchMoreActivities());
        },
    };
}

const mapStateToProps = function (state: NutshellState): StateProps {
    return {
        activities: selectors.getActivityList(state),
        hasError: Boolean(selectors.getListErrorMessage(state)),
        hasNextPage: Boolean(selectors.shouldLoadMoreActivities(state)),
        scrolledToDate: selectors.getScrolledToDate(state),
        isRequesting: selectors.getIsRequesting(state),
        sidebarWidth: dashboardSelectors.getRightPaneWidth(state),
    };
};

type OwnProps = {
    userId: string;
    onStartEmailToParticipant: (entityId: string) => any;
    onStartCallToParticipant: (arg1: {
        entityId: string;
        phoneNumber: {
            E164: string;
            numberFormatted: string;
        };
        anchorElementId: string;
    }) => void;
};

type StateProps = {
    isRequesting: boolean;
    sidebarWidth: number;
    activities: any[];
    hasError: boolean;
    hasNextPage: boolean;
    scrolledToDate: number;
};

type DispatchProps = {
    onFetchMoreRows: () => any;
    onScrolledToDate: (date: number) => any;
    onClearActivityListError: () => any;
};

type Props = OwnProps & StateProps & DispatchProps;

export class ActivityListComponent extends React.Component<Props> {
    render() {
        return (
            <GetCalendarSync>
                {({calendarSync}) => (
                    <div className={styles['activity-list']}>
                        <ListViewInfiniteActivities
                            isRequesting={this.props.isRequesting}
                            onFetchMoreRows={this.props.onFetchMoreRows}
                            hasNextPage={this.props.hasNextPage}
                            width={this.props.sidebarWidth}
                            collection={this.props.activities}
                            emptyState='No upcoming activities'
                            renderListRow={(index) =>
                                this.renderListRow(this.props.activities[index])
                            }
                            onRowsRenderedCallback={this.handleRowsRendered}
                            hasError={this.props.hasError}
                            onClearListError={this.props.onClearActivityListError}
                            userHasCalendarSyncEnabled={Boolean(
                                calendarSync && calendarSync.isEnabled
                            )}
                        />
                    </div>
                )}
            </GetCalendarSync>
        );
    }

    renderListRow = (activity: any) => {
        if (activity.type === 'headers') {
            return <DateHeader customFormat={'ddd, MMMM Do'} date={activity.date} />;
        }

        return (
            <ActivityListItem
                userId={this.props.userId}
                activity={activity}
                onStartCallToParticipant={this.props.onStartCallToParticipant}
                onStartEmailToParticipant={this.props.onStartEmailToParticipant}
            />
        );
    };

    handleRowsRendered = (indicies: Indices) => {
        const {startIndex} = indicies;
        if (this.props.activities[startIndex] && this.props.activities.length) {
            const activity = this.props.activities[startIndex];
            const date =
                activity.type === 'headers'
                    ? moment.unix(activity.date).startOf('day').valueOf()
                    : moment.unix(activity.startTime).startOf('day').valueOf();

            if (this.props.scrolledToDate !== date) {
                this.props.onScrolledToDate(date);
            }
        }
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);

export const ActivityList = connector(ActivityListComponent);
